module.exports = __webpack_public_path__ + "img/blue_137.99863d17.png";